import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  putCustomerOrderChargesInfoUpdate,
} from "../../services/OrderEdit/orderInfoEdit";
import {
  getCustomerSingleOrderInfo,
  getOrderItemQrCodeMap,
} from "../../services/OrdersAPI/Orders";
import ButtonLink from "../../ButtonLink";

const GarmentEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeCustomerId, bookingOrderId, storeId } = location.state || {}; // Fallback to prevent undefined errors

  const [customerOrdersData, setCustomerOrdersData] = useState({});
  const [orderItemQrCodeMap, setOrderItemQrCodeMap] = useState({});
  const [selectedQrCodeData, setSelectedQrCodeData] = useState([]);

  const fetchGarmentEditData = () => {
    getCustomerSingleOrderInfo(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOrdersData(Res);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });

    getOrderItemQrCodeMap(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setOrderItemQrCodeMap(Res);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });
  };

  useEffect(() => {
    fetchGarmentEditData();
  }, []);
  const [garmentEditModalVisible, setGarmentEditModalVisible] = useState(false);

  const handleOrderItemQrCodeMap = (id) => {
    // const qrCodeData = orderItemQrCodeMap[service.orderItemId];
    const qrCodeData = orderItemQrCodeMap[id];
    const orderBookingType = customerOrdersData?.orderItem.find(
      (item) => item.id === id
    );

    if (qrCodeData !== undefined) {
      setSelectedQrCodeData(qrCodeData);
      navigate("/GarmentEditWithScanner", {state:{
        qrCodeData: qrCodeData,
        orderItemData: customerOrdersData?.orderItem,
        storeCustomerId: storeCustomerId,
        bookingOrderId: bookingOrderId,
        orderBookingType: orderBookingType,
      }});
    }
    // setGarmentEditModalVisible(true);
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [errorText, setErrorText] = useState("");

  const receiveDataFromBookingInfoCharges = ({ success }) => {
    if (success) {
      fetchGarmentEditData();
    }
  };

  const handleRemoveAppliedCharge = (item) => {
    const data = {
      ...item,
      amount: parseInt(0),
      count: parseInt(0),
    };

    putCustomerOrderChargesInfoUpdate(
      storeCustomerId,
      storeId,
      bookingOrderId,
      data
    )
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const message = Res.message;
          const status = Res.status;
          fetchGarmentEditData();
          if (status === true) {
            setModalVisible(true);
            setModalStatus("success");
            setModalText(message);
          } else {
            setModalVisible(true);
            setModalStatus("not Success");
            setModalText(message);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const renderCardItem = () => {
    return customerOrdersData?.orderItem?.map((item, index) => {
      const garmentName =
        item.garmentAlias !== "" ? item.garmentAlias : item.garmentName;

      const gradientColors =
        "radial-gradient(circle at left top, #6b88f2, #1742db)";

      return (
        <div>
          <div>
            <div className="ml-6">
              <div
                className=" flex flex-1 my-1 mx-1 border-round-3xl shadow-4 my-2"
                style={{
                  backgroundImage: gradientColors,
                }}
              >
                <div className="flex flex-1 grid justify-content-between align-items-center ml-3 mt-0">
                  <p className="col text-lg text-white font-medium capitalize">
                    {garmentName?.replace(/_/g, " ")}
                  </p>
                  <p className="col text-lg text-white font-medium capitalize">
                    {item.garmentService}
                  </p>
                  <p className="col text-lg text-white font-medium capitalize">
                    {orderItemQrCodeMap[item.id]?.length}
                  </p>
                  <div className="flex col text-lg text-white font-medium capitalize gap-3">
                    {orderItemQrCodeMap[item.id]?.length > 0 && (
                      <div
                        onClick={() => {
                          handleOrderItemQrCodeMap(item.id);
                        }}
                      >
                        <i
                          className="pi pi-pencil"
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                            color: "#fff",
                          }}
                        ></i>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-1">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/OrdersGarmentInfo", {
                      state: {
                        storeCustomerId: storeCustomerId,
                        bookingOrderId: bookingOrderId,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Edit Garments
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div>
          <div>
            <div>
              <div className="ml-6">
                <div
                  className=" flex flex-1 my-1 mx-1 border-round-3xl shadow-4 mt-2 mb-3"
                  style={{
                    backgroundImage:
                      "radial-gradient(circle at left top, #6b88f2, #1742db)",
                  }}
                >
                  <div className="flex flex-1 grid justify-content-between align-items-center ml-3 mt-0">
                    <div className="col">
                      <p className="text-xl text-white font-bold capitalize">
                        Garment
                      </p>
                    </div>
                    <p className="col text-xl text-white font-bold capitalize">
                      Service
                    </p>
                    <p className="col text-xl text-white font-bold capitalize">
                      Tags
                    </p>
                    <p className="col text-xl text-white font-bold capitalize"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>{renderCardItem()}</div>
        </div>
        {/* <GarmentEditModal
          setGarmentEditModalVisible={setGarmentEditModalVisible}
          garmentEditModalVisible={garmentEditModalVisible}
          selectedQrCodeData={selectedQrCodeData}
        /> */}

      </div>
        <div className="absolute bottom-0  mx-6 my-3">
          <div className="flex flex-1 flex-row gap-6">
            <p className="text-lg font-normal" style={{color:"#1742db"}}>Note *</p>
            <p className="text-lg font-normal" style={{color:"#1742db"}}>
              Once the garment is unprocessed, the edit feature will be disabled
            </p>
          </div>
        </div>
        <ButtonLink />
    </div>
  );
};

export default GarmentEdit;
